import StatusBadge from "components/Common/StatusBadge"
import { CanView } from "components/Common/CanView"
import DisplayToggle from "components/Common/DisplayToggle"
import { ACCESS } from "constants/accessPermissions"
import { formatReadableDate } from "utils/formatDate"

const StockStatusCell = ({ stock }) => {
  return (
    <div className="text-wrap">
      {stock.location?.name ?? "-"}

      <div className="text-muted d-block mt-1">
        {stock.status ? <StatusBadge value={stock.status} /> : "-"}
      </div>
      {/* created_at: added in stocks */}
      <small className="text-muted d-block mt-1">
        {stock.created_at ? formatReadableDate(stock.created_at) : "-"}
      </small>

      {!!stock.importer?.name && (
        <CanView access={[ACCESS.STOCK.VIEW_IMPORTER]}>
          <DisplayToggle>
            <small>Ref.: {stock.importer?.name}</small>
          </DisplayToggle>
        </CanView>
      )}
    </div>
  )
}

export default StockStatusCell
